import React from 'react';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import CustomerForm from "./customerComponents/CustomerForm";
import { useAddCustomerMutation } from "store/services/customerApi";
import { useAppMeta } from "hooks";

const CustomerCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Customer Profile List", path: "/app/crm/customerProfile/list" },
    { title: "New Customer Profile" },
  ];

  // RTK Query
  const [
    createCustomer,
    { isLoading: creatingCustomer }
  ] = useAddCustomerMutation();

  // methods 
  const handleAddCustomer = async (data) => {
    try {
      const { customer } = await createCustomer(data).unwrap();
      toast.success("Customer Created Successfully!");
      navigate(`/app/crm/customerProfile/${customer._id}/detail`);
    } catch (error) {
      toast.error(error?.data?.message ?? error?.message ?? "Could not create customer!");
    }
  };

  useAppMeta("New Customer");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingCustomer}>
      <BreadcrumbLayout.Paper>
        <CustomerForm isBusy={creatingCustomer} onSubmit={handleAddCustomer} />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default CustomerCreateScreen;